import * as swcHelpers from '@swc/helpers';
import React__default, { useState } from 'react';
import classnames from 'classnames';
import { FormContext } from '../Form/Form.js';
import FormControl from '../FormControl/FormControl.js';

const MultipleAddressLine = ({ addLineLabel , errorMessage , getInitialState , initialLineAmount =1 , label , lineThreeLabel , lineTwoLabel , maxLength , required =true , shouldCombineAddress =false , streetComponent: Street = FormControl , validations  })=>{
    const [lineAmount, setLineAmount] = useState(initialLineAmount);
    const additionalStreetInfoValue = getInitialState && getInitialState('additionalStreetInfo');
    const additionalAddressInfoValue = getInitialState && getInitialState('additionalAddressInfo');
    if (additionalStreetInfoValue && additionalStreetInfoValue.value && lineAmount < 2) {
        setLineAmount(2);
    }
    if (additionalAddressInfoValue && additionalAddressInfoValue.value && lineAmount < 3) {
        setLineAmount(3);
    }
    const handleClick = ()=>{
        setLineAmount(lineAmount + 1);
    };
    const inputs = [
        /*#__PURE__*/ React__default.createElement(Street, swcHelpers.extends({}, FormControl.defaultProps, {
            id: "streetName",
            key: "streetName",
            "data-t": "streetName",
            label: label,
            initialState: getInitialState && getInitialState('streetName'),
            errorMessage: errorMessage,
            validations: validations,
            required: required,
            maxLength: maxLength,
            shouldCombineAddress: shouldCombineAddress
        })),
        /*#__PURE__*/ React__default.createElement("div", {
            key: "additionalStreetInfo",
            "data-t": "additionalStreetInfo",
            className: classnames('multiple-address-line__additional-line', {
                'multiple-address-line__additional-line--hidden': lineAmount < 2
            })
        }, /*#__PURE__*/ React__default.createElement(FormControl, swcHelpers.extends({}, FormControl.defaultProps, {
            id: "additionalStreetInfo",
            key: "additionalStreetInfo",
            "data-t": "additionalStreetInfoFormControl",
            required: false,
            initialState: getInitialState && getInitialState('additionalStreetInfo'),
            errorMessage: errorMessage,
            validations: validations,
            maxLength: maxLength,
            label: lineTwoLabel
        }))),
        /*#__PURE__*/ React__default.createElement("div", {
            key: "additionalAddressInfo",
            "data-t": "additionalAddressInfo",
            className: classnames('multiple-address-line__additional-line', {
                'multiple-address-line__additional-line--hidden': lineAmount < 3
            })
        }, /*#__PURE__*/ React__default.createElement(FormControl, swcHelpers.extends({}, FormControl.defaultProps, {
            key: "additionalAddressInfo",
            id: "additionalAddressInfo",
            "data-t": "additionalAddressInfoFormControl",
            required: false,
            initialState: getInitialState && getInitialState('additionalAddressInfo'),
            errorMessage: errorMessage,
            validations: validations,
            maxLength: maxLength,
            label: lineThreeLabel
        }))), 
    ];
    return /*#__PURE__*/ React__default.createElement("div", {
        className: "multiple-address-line"
    }, inputs, lineAmount < inputs.length && /*#__PURE__*/ React__default.createElement("button", {
        type: "button",
        className: "multiple-address-line__add-lines",
        onClick: handleClick
    }, addLineLabel));
};
const ConnectedMultipleAddressLine = (_param)=> {
    var props = swcHelpers.extends({}, _param);
    return React__default.createElement(FormContext.Consumer, null, (context = {})=>/*#__PURE__*/ React__default.createElement(MultipleAddressLine, swcHelpers.extends({}, props, {
            getInitialState: context.getInitialState
        }))
    );
};
ConnectedMultipleAddressLine.defaultProps = swcHelpers.objectSpread({}, MultipleAddressLine.defaultProps);
var ConnectedMultipleAddressLine$1 = ConnectedMultipleAddressLine;

export { MultipleAddressLine, ConnectedMultipleAddressLine$1 as default };
//# sourceMappingURL=MultipleAddressLine.js.map
